<template>

<div>
  <b-form @submit="onSubmit" class="text-center">
    <b-row class="pt-4">
      <b-col>
        <h3>{{$t('label.forgetPassword')}}</h3>
      </b-col>
    </b-row>
    <!-- email -->
    <b-row align-h="center">
        <b-col sm="6" class="mt-4">
        <b-form-input v-model.trim="$v.form.email.$model" :placeholder="$t('label.email')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.email.required && $v.form.email.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.email.email && $v.form.email.$dirty">{{ $t("info.email") }}</div>
        <div class="text-danger" v-if="!$v.form.email.maxLength && $v.form.email.$dirty">{{ $t("info.maxLength", [75]) }}</div>
        </b-col>
    </b-row>
    
    <b-button class="mt-4" type="submit" variant="success" :disabled="disabled">{{ $t("label.submit") }}</b-button>

  </b-form>

    <!-- spinner -->
    <div v-if="spinner" class="text-center pt-2">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>

    <!-- Success -->
    <div v-if="success" class="text-center pt-4">
        <b-alert sm="6" show variant="success">
            <p>{{ $t("info.succesGeneric") }}</p>
        </b-alert>
    </div>

    <!-- User not exist -->
    <div v-if="noExistingUser" class="text-center pt-4">
        <b-alert sm="6" show variant="warning">
            <p>{{ $t("info.noExistingUser") }}</p>
        </b-alert>
    </div>

    <!-- error -->
    <div v-if="error" class="text-center pt-4">
        <b-alert sm="6" show variant="danger">
            <p>{{ error }}</p>
        </b-alert>
    </div>
    
</div>
</template>

<script>
import axios from 'axios';
import { required, email, maxLength } from 'vuelidate/lib/validators';

export default {
props: [],
data() {
    return {
      form: {
        email: ""
      },     
      error: "",
      noExistingUser: false,
      disabled: false,
      spinner: false,
      success: false
    }
  },
validations() {
    return {
      form: {        
        email: {
          required,
          email,
          maxLength: maxLength(75)
        }
    }
  }
},
computed: {
  url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  }
},
methods:{
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('forgetPaswd');

      return token;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.error = "";      
      this.$v.$touch();
      if (!this.$v.$invalid) { 
          
          this.disabled = true;
          this.spinner = true;
          this.noExistingUser = false;
          this.success = false;

          let promise = this.recaptcha();
          promise.then((token) => {

            let obj = {
              response: token
            }

            axios.post(this.url, {request: "getCaptchaResponse", form: obj }, { headers: {'Content-Type': 'application/json'}})
              .then((response)  => {
                let resp = JSON.parse(response.data);
                if (resp.success && resp.action === 'forgetPaswd' && resp.score > 0.5) {                 
                  this.forgetPaswd();
                }
                else {
                  this.disabled = false;
                  this.spinner = false;
                  this.error = this.$t('info.errorCaptcha');
                }
              })
              .catch(()  => {
                  this.disabled = false;
                  this.spinner = false;
                  this.error = this.$t('info.errorgeneric');
              });

          });
          
      }
    },
    forgetPaswd() {
          axios.post(this.url, {request: "forgetPassword", form: this.form }, { headers: {'Content-Type': 'application/json'}})
            .then((response)  => {
                //this.disabled = false;
                this.spinner = false;

                if (response.data.status === 0 && response.data.statusEmail === 202) {
                  this.success = true;
                }
                else if(response.data.status === 1) {
                  this.noExistingUser = true;
                }
                else {
                  this.error = this.$t('info.errorgeneric');
                }
                
            })
            .catch(()  => {
                this.error = this.$t('info.errorgeneric');
                this.spinner = false;
                this.disabled = false;
            }); 
    },
    setNextPage(page) {      
      this.$emit('changePage', page);        
    }
},
components: {}
}
</script>